module.exports = __webpack_public_path__ + "img/Dantam Bridal 25.24cf6328.jpg";